export const environment = {
    production: false
};


export const environmentURL = {
    production: false,
    /** Comentario: en desarrollo se limita la carga inicial de socios para acelerar la búsqueda */
    maestroBusquedaMaxRegistros: 1000,
    
    // apiBaseUrl: 'http://localhost:7071/api/',
    // apiBackendUrl: 'http://localhost:7072/api/',
    // apiIaUrl: 'http://localhost:7073/api/',
    // apiEventosUrl: 'http://localhost:7074',


    // apiIaUrl: 'https://ivan.elsegurodelmaestro.org.mx/api/',
    // apiBaseUrl: 'https://pao.elsegurodelmaestro.org.mx/api/',
    // apiBackendUrl: 'https://faus.elsegurodelmaestro.org.mx/api/',
    // apiEventosUrl: 'http://localhost:7074',





    
    // apiBaseUrl: 'https://pao.elsegurodelmaestro.org.mx/api/',
    // apiBackendUrl: 'https://faus.elsegurodelmaestro.org.mx/api/',
    // apiIaUrl: 'https://ivan.elsegurodelmaestro.org.mx/api/',

    apiBaseUrl: 'https://sdm-ms.azurewebsites.net/api/',
    apiBackendUrl: 'https://sdm-backend.azurewebsites.net/api/',
    apiIaUrl: 'https://sdm-ia.azurewebsites.net/api/',
    apiEventosUrl: 'http://localhost:7074',

    sessionTimeOut: 24 * 60 * 60 * 1000, // 24 horas en milisegundos
    
    /** Token fijo Kardex (WEB_APP_CLIENT_TOKEN en Azure); debe coincidir con ms/backend en fase 2. */
    webAppClientToken: 'WebAppKardex2025',
};
